"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUERY_PARAM = void 0;
exports.QUERY_PARAM = {
    REFERRAL: "ref",
};
